import { useEffect } from "react";
import { gestureWebsiteUrl, redirectAllowlist } from "../../settings";

export default function RedirectDeepLink() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const deepLink = params.get("url");
    const fallbackUrl = gestureWebsiteUrl;

    const validAllowlist = Array.isArray(redirectAllowlist)
      ? redirectAllowlist.filter(
          (d) => typeof d === "string" && /^[a-z0-9.-]+$/i.test(d.trim())
        )
      : [];
    if (validAllowlist.length === 0) {
      console.warn(
        "Invalid or empty redirect allowlist. Redirecting to fallback."
      );
      window.location.replace(fallbackUrl);
      return;
    }
    const isValidUrl = (url) => {
      try {
        const parsed = new URL(url);

        // must be https and domain must match exactly or be canonical subdomain
        const isHttps = parsed.protocol === "https:";
        const allowed = validAllowlist.some((allowedHost) => {
          const normalizedAllowed = allowedHost.toLowerCase();
          const host = parsed.hostname.toLowerCase();

          // exact match or a sanctioned subdomain pattern only (e.g. "app.link")
          return (
            host === normalizedAllowed ||
            host === `www.${normalizedAllowed}` ||
            (normalizedAllowed.startsWith("*.") &&
              host.endsWith(normalizedAllowed.slice(1)))
          );
        });

        return isHttps && allowed;
      } catch {
        return false;
      }
    };

    window.history.replaceState(null, "", window.location.pathname);
    if (!deepLink || !isValidUrl(deepLink)) {
      window.location.replace(fallbackUrl);
      return;
    }

    window.location.href = deepLink;
    const timer = setTimeout(() => {
      window.location.replace(fallbackUrl);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <h2>Opening Gesture app...</h2>
      <p>
        If nothing happens, you’ll be redirected to{" "}
        <a href={gestureWebsiteUrl}>{gestureWebsiteUrl}</a> shortly.
      </p>
    </div>
  );
}
